import React from "react";
import Style from "./NewFactor.module.scss";
import { separate } from "../../../../Utils/SeprateNumber/SeprateThreeNumber";
const NewFactor = ({ info }) => {
  console.log(info)
  let total = null;
  let items = null;
  return (
    <div>
      {info?.suppliers?.map((item, index) => {
        return (
          <div key={index}>
            <p className={Style.supplierName}>محصولات {item.name} </p>
            {item.products.map((element,index) => {
              total = element.new_price * element.new_count + total;
              if (
                element.availability === "1" &&
                element.price === element.new_price &&
                element.count === element.new_count &&
                element.p_product_id === "0"
              ){
              } else {
                items = (
                  <div
                    key={index}
                    className={
                      element.availability === "1"
                        ? Style.orderInfo
                        : Style.nullOrder
                    }
                  >
                    <p className={Style.food}>{element.name}</p>
                    <p className={Style.count}>{element.new_count} عدد</p>
                    <p className={Style.price}>
                      {separate(element.new_price * element.new_count)}
                      <span style={{ fontSize: ".7rem" }}>تومان</span>
                    </p>
                    <p className={Style.productFee}>
                      {" "}
                      {separate(element.product_fee * element.new_count)}
                      <span style={{ fontSize: ".7rem" }}>تومان کارمزد </span>
                    </p>
                  </div>
                );
              }
              return items;
            })}
          </div>
        );
      })}
      <div className={Style.totalPrice}>
        {" "}
        <span className={Style.textPrice}> مجموع فاکتور: </span> {total}{" "}
      </div>
    </div>
  );
};

export default NewFactor;
